import { render } from "./apply1_1.vue?vue&type=template&id=537dd473&scoped=true"
import script from "./apply1_1.vue?vue&type=script&lang=js"
export * from "./apply1_1.vue?vue&type=script&lang=js"

import "./apply1_1.vue?vue&type=style&index=0&id=537dd473&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537dd473"]])

export default __exports__